import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FundAccountModel {
  buyAmount = 0;
  payAmount = 0;
  exchangeRate = 0;
  exchangeFee = 0;
  valueDate: '';
  currencyCodeBuy = {
    code: '',
    id: ''
  };
  currencyCodePay = {
    code: '',
    id: ''
  };
  tradeReference: '';
  tradeId: '';
  deposited = 0;
  showDeposited = false;
  isSellChanged: boolean;
  isForwardTrade = false;
  holidays = [];
  depositCurrencyId: string;

  // IOT
  iotInfo = {
    redirectedFromIOT: false,
    processedOkIOT: false
  };

  quoteId?: string;
}
